import Label from "components/general/Label"
import { filterArray, findArray } from 'helpers/utils'
import { ResultRank } from "components/presentation/ResultRank"
import SportCode from "components/common/SportCode";



export function getIsIndividual(rsc) {
  return (rsc?.match("TRI[MW][OLYMPIC|SPRINT-].+"));
}

export function getIsPTVPTW(rsc) { //fixme change it to a more elegant regex
  let ptv = "SPRINT--03031-----"
  let ptw = "SPRINT--02022-----"
  return (rsc?.includes(ptv) || rsc?.includes(ptw));
}
export function getIsMixed(rsc) {
  return (rsc?.match("TRIXTEAM4.+"));
}

export function hasConfig(config) {
  let sw = config?.filter(rowConf => rowConf?.code === 'INTERMEDIATE').length > 0
  return (
    sw
  )
}


export function createColumnsIntermediate(columnsAdded, isMobil = false) {
  let config = columnsAdded
  config = config?.intermediates?.filter(i => i?.sector?.code !== 'START')
  let columnsExt = []

  Array.isArray(config) && config?.map((item) => {
    let configSplit = (item?.sector?.code !== undefined)
      ? <SportCode entity='@Segment' code={item?.sector?.code} />
      : <span></span>

    let splitDistance = (item?.sector?.value !== undefined)
      ? (item?.sector?.code === 'SWIM')
        ? <span> {item?.sector?.valueIntermediate}<Label data='LabelM' /></span>
        : <span> {item?.sector?.valueIntermediate}<Label data='LabelKm' /></span>
      : ''

    let header = item?.sector?.posIntermediate === 'F' && (item?.sector?.code === 'RUN' || item?.sector?.code === 'RUN2')
      ? <Label data="HeaderFinish" />
      : <span>{configSplit} {splitDistance}</span>

    columnsExt.push(
      {
        Header: header,
        accessor: (props) => (
          props?.extendedResults
            ? findArray(props.extendedResults, { er_type: [item?.sector?.code], er_code: ['INTERMEDIATE'], er_pos: [item?.sector?.posIntermediate] })?.er_sortorder
            : ''
        ),
        Cell: (props) => (
          getCell(props.cell.row.original, item?.sector?.posIntermediate, item?.sector?.code, isMobil)
        ),
        isVisible: false,
        disableSortBy: false,
        columnIndex: item?.position,
        id: 'Splits-' + item?.position,
        className: 'text-end',
        headerClassName: 'text-center w-10'
      },
    )
  })
  return (
    columnsExt
  )
}

export function createColumnsSummary(columnsAdded, isMobil = false) {

  let config = columnsAdded
  let columnsExt = []
  let split = 0;
  let configFilter = filterArray(config, { type: ['COURSE'] })
  configFilter && configFilter.sort((a, b) => a.pos - b.pos).map((configItem) => {
    let configExtended = filterArray(configItem?.extension, { code: ['INTERMEDIATE'], pos: ['F'] })
    configExtended && configExtended.sort((a, b) => (a.pos === 'F' ? 999 : a.pos) - (b.pos === 'F' ? 999 : b.pos)).map((item, key) => {
      split = split + 1;
      let configSplit = (configItem.code !== undefined)
        ? <SportCode entity='@Segment' code={configItem.code} />
        : <> {configItem.code} </>

      let header = <> {configSplit} </>;
      columnsExt.push(
        {
          Header: header,
          accessor: (props) => (
            props?.extendedResults
              ? findArray(props.extendedResults, { er_code: [configItem?.code], er_type: ['SUMMARY'] })?.er_sortorder
              : ''
          ),

          Cell: (props) => (
            getCellSummary(props.cell.row.original, configItem.code, isMobil)
          ),
          isVisible: false,
          disableSortBy: false,
          columnIndex: split,
          id: 'Splits-' + split,
          className: 'result text-end',
          headerClassName: 'text-end w-10',
        },

      )
    })
  })
  return (
    columnsExt
  )
}

export function createColumnsMixedSummary(columnsAdded, isMobil) {

  let config = columnsAdded
  let columnsExt = []
  let max = 0;
  let numAthletes = []


  config?.forEach(c => {
    c?.extension?.forEach(d => {
      if (d?.code === 'LEG' && Number(d?.pos) > max) {
        max = Number(d?.pos)
        numAthletes.push(d?.value);
      }
    })
  })
  let colums = 0
  numAthletes?.map((athId) => {
    colums = colums + 1
    let header = <> <Label data={`HeaderLeg`} /> {athId}</>;

    columnsExt.push(
      {
        Header: header,
        accessor: (props) => {
          let arr = findArray(props?.teamAthletes, { startOrder: [athId] })
          let arr2 = findArray(arr?.extResults, { er_type: ['RUN'], er_code: ['INTERMEDIATE'], er_pos: ['F'] })
          return arr2?.er_sortorder
        },

        Cell: (props) => {
          let row = props.cell.row.original;
          let arr = findArray(row?.teamAthletes, { startOrder: [athId] })
          let arr2 = findArray(arr?.extResults, { er_type: ['RUN'], er_code: ['INTERMEDIATE'], er_pos: ['F'] })
          return isMobil ? arr2?.er_value : <ResultRank result={arr2?.er_value} rank={arr2?.er_rank} />;
        },
        isVisible: false,
        disableSortBy: false,
        //columnIndex: athId,
        id: 'Splits-' + athId,
        className: 'text-end',
        headerClassName: 'text-end w-10',
        columnIndex: colums,
      },
    )
  })
  return (
    columnsExt
  )
}

export function createColumnsMixedSummary2(columnsAdded) {

  let config = columnsAdded
  let columnsExt = []
  let split = 0;
  let max = 0;
  config?.forEach(c => {
    c?.extension?.forEach(d => {
      if (d?.code === 'INTERMEDIATE_ALL' && Number(d?.value) > max) {
        max = Number(d?.value)
      }
    })
  })

  let configFilter = filterArray(config, { type: ['COURSE'] })

  configFilter && configFilter.sort((a, b) => a.pos - b.pos).map((configItem) => {
    let configExtended = filterArray(configItem?.extension, { code: ['INTERMEDIATE'], pos: ['F'] })
    let configExtendedAll = filterArray(configItem?.extension, { code: ['INTERMEDIATE_ALL']/*, pos: ['F'] */ })

    let position = Array.isArray(configExtendedAll) && configExtendedAll?.sort((a, b) => (b?.value - a?.value))[0]?.value;
    configExtended && configExtended.sort((a, b) => (a.pos === 'F' ? 999 : a.pos) - (b.pos === 'F' ? 999 : b.pos)).map((item, key) => {
      split = split + 1;
      let configSplit = (configItem.code !== undefined)
        ? <Label data={`Header${configItem.code}`} />
        : <> {configItem.code} </>

      let header = <> {configSplit} </>;
      columnsExt.push(
        {
          Header: header,
          accessor: (props) => (
            props?.extendedResults &&
            findArray(props.extendedResults, { er_type: [configItem?.code], er_code: ['INTERMEDIATE'], er_pos: ['position'] })
            // : ''
          ),

          Cell: (props) => {
            let row = props.cell.row.original;
            if (Number(position) === max) position = 'F'
            let arr = findArray(row?.extendedResults, { er_type: [configItem?.code], er_code: ['INTERMEDIATE'], er_pos: [position] })
            return arr?.er_value;
          },
          isVisible: false,
          disableSortBy: false,
          columnIndex: split,
          id: 'Splits-' + split,
          className: 'result',
          headerClassName: 'text-center w-10',
        },

      )
    })
  })
  return (
    columnsExt
  )
}

export function createColumnsIntermTeams(columnsAdded, isMobil = false) {
  let config = columnsAdded?.intermediates?.filter(i => i?.sector?.code !== 'START')
  let columnsExt = []
  Array.isArray(config) && config.map((item) => {
    let configLeg = item?.sector?.leg?.value

    let configSplit = (item?.sector?.code !== undefined)
      ? <><Label data="HeaderLeg" /> {configLeg} - <SportCode entity='@Segment' code={item?.sector?.code} /></>
      : <span></span>

    let splitDistance = (item?.sector?.valueIntermediate !== undefined)
      ? (item?.sector?.code === 'SWIM')
        ? <span> {item?.sector?.valueIntermediate}<Label data='LabelM' /></span>
        : <span> {item?.sector?.valueIntermediate}<Label data='LabelKm' /></span>
      : ''

    let header = item?.position === columnsAdded?.finalPosition
      ? <Label data="HeaderTotalTime" />
      : <span>{configSplit} {splitDistance}</span>
    columnsExt.push(
      {
        Header: header,
        accessor: (row) => {

          //let athlete = findArray(row.teamAthletes, { order: [Number(item?.sector?.leg?.pos)] })
          //let intermediate = findArray(athlete.extResults, { er_type: [item?.sector?.code], er_code: ['INTERMEDIATE'], er_pos: [item?.sector?.posIntermediate] })

          let teamInter = findArray(row?.extendedResults, { er_type: [item?.sector?.code], er_code: ['INTERMEDIATE'], er_pos: [item?.sector?.intermediateAll] })

          return (teamInter?.er_sortorder)
        },
        //getCellTeams(row, legOrder, type, split, isMobil) {
        Cell: (props) => (
          getCellTeams(props.cell.row.original, item?.sector?.leg?.pos, item?.sector?.code, item?.sector?.intermediateAll, isMobil)
        ),
        isVisible: false,
        disableSortBy: false,
        columnIndex: item?.position,
        id: 'Splits-' + item?.position,
        className: 'text-end',
        headerClassName: 'text-center w-10'
      },
    )
  })
  return (
    columnsExt
  )

}

export function createColumnsSummaryTeams(columnsAdded, isMobil = false) {

  //let config = columnsAdded
  let legArray = ['A', 'B', 'C', 'D']
  let columnsExt = []
  let intermediates = columnsAdded?.intermediates
  legArray.forEach((legItem, index) => {
    let leg = intermediates?.filter(intermediate => intermediate?.sector?.leg?.value === legItem)
    let legMaxPos = Math.max.apply(Math, leg.map(function (o) {
      return o.position;
    }));
    let sector = columnsAdded?.intermediates?.find(item => item?.position === legMaxPos)?.sector
    let header = <><Label data={'HeaderLeg'} />: {legItem}</>
    columnsExt.push(
      {
        Header: header,
        accessor: (row) => {
          let athlete = row?.teamAthletes?.find(athlete => athlete?.startOrder === legItem)
          return (
            athlete?.extResults
              ? findArray(athlete?.extResults, { er_code: ['INTERMEDIATE'], er_type: [sector?.code], er_pos: [sector?.posIntermediate.toString()] })?.er_sortorder
              : ''
          )
        },
        Cell: (props) => {

          let row = props.cell.row.original;
          let athlete = row.teamAthletes.find(athlete => athlete?.startOrder === legItem)
          let athleteData = findArray(athlete?.extResults, { er_code: ['INTERMEDIATE'], er_type: [sector?.code], er_pos: [sector?.posIntermediate.toString()] })
          let rankEqual = athleteData?.er_rankequal === 'Y' ? '=' : ''
          let rank = athleteData?.er_rank && rankEqual + athleteData?.er_rank
          return (
            athlete?.extResults
              ? isMobil ? athleteData?.er_value : <ResultRank result={athleteData?.er_value} rank={rank} />
              : ''
          )
        },
        isVisible: false,
        disableSortBy: false,
        columnIndex: index + 1,
        id: 'Splits-' + index + 1,
        className: 'result text-end',
        headerClassName: 'text-end w-10 text-nowrap',
      },

    )
  });

  return (
    columnsExt
  )
}


function getCellBorrar(row, split, type, isMobil) {
  let cell = null

  if (!!row) {
    let photo = row?.extendedResults ? row?.extendedResults.filter(row => (row?.er_code === 'PHOTO' && row?.er_value === 'P')).map((val) => { return (val?.er_value) }) : ''
    let intermediate = findArray(row?.extendedResults, { er_type: [type], er_code: ['INTERMEDIATE'], er_pos: [split] })
    let rankEqual = intermediate?.er_rankequal === 'Y' ? '=' : ''
    let rank = intermediate?.er_rank && rankEqual + intermediate?.er_rank
    cell = (row?.resultType !== 'IRM')
      ? ((split === row?.finalSplit && (type === 'RUN' || type === 'RUN2')) || isMobil)
        ? (photo && photo.length) > 0
          ? ''
          : <ResultRank result={intermediate?.er_value} rank={rank} />
        : ''
      : row.resultIrm
  }
  return cell
}


function getCell(row, split, type, isMobil) {
  let cell = null
  if (!!row) {
    let photo = row?.extendedResults ? row?.extendedResults.filter(row => (row?.er_code === 'PHOTO' && row?.er_value === 'P')).map((val) => { return (val?.er_value) }) : ''
    let intermediate = findArray(row?.extendedResults, { er_type: [type], er_code: ['INTERMEDIATE'], er_pos: [split] })
    let rankEqual = intermediate?.er_rankequal === 'Y' ? '=' : ''
    let rank = intermediate?.er_rank && rankEqual + intermediate?.er_rank

    cell = (row?.resultType !== 'DNS')
      ? ((split === row?.finalSplit && (type === 'RUN' || type === 'RUN2')) || isMobil)
        ? (photo && photo.length) > 0
          ? ''
          : intermediate?.er_value
        : isMobil ? intermediate?.er_value : <ResultRank result={intermediate?.er_value} rank={rank} />
      : ''//<>{row?.resultIrm} </>
  }
  return cell
}


function getCellTeams(row, legOrder, type, split, isMobil) {
  let cell = null
  if (!!row) {
    let athlete = findArray(row?.teamAthletes, { order: [Number(legOrder)] })
    //let intermediate = findArray(athlete.extResults, { er_type: [type], er_code: ['INTERMEDIATE'], er_pos: [split] })
    //let interIrm = findArray(row.extendedResults, { er_type: ['TEAM'], er_code: ['LEG'], er_pos: [split] })

    let photo = row?.extendedResults ? row?.extendedResults.filter(row => (row?.er_code === 'PHOTO' && row?.er_value === 'P')).map((val) => { return (val?.er_value) }) : ''
    let teamIntermediate = findArray(row?.extendedResults, { er_type: [type], er_code: ['INTERMEDIATE'], er_pos: [split] })
    let rankEqual = teamIntermediate?.er_rankequal === 'Y' ? '=' : ''
    let rank = teamIntermediate?.er_rank && rankEqual + teamIntermediate?.er_rank
    //cell = (intermediate?.er_valuetype !== 'IRM')
    cell = (row?.resultType !== 'IRM')
      ? (photo && photo.length) > 0 && split === 'F'
        ? ''
        : isMobil
          ? teamIntermediate?.er_value
          : split === 'F' ? teamIntermediate?.er_value : <ResultRank result={teamIntermediate?.er_value} rank={rank} />
      : <ResultRank result={teamIntermediate?.er_value} rank={rank} />

  }
  return cell
}

function getCellSummary(row, code, isMobil) {
  let cell = null
  if (!!row) {
    let intermediate = findArray(row.extendedResults, { er_code: [code], er_type: ['SUMMARY'] })
    let rankEqual = intermediate?.er_rankequal === 'Y' ? '=' : ''
    let rank = intermediate?.er_rank && rankEqual + intermediate?.er_rank

    cell = isMobil ? intermediate?.er_value : <ResultRank result={intermediate?.er_value} rank={rank} />

  }
  return cell
}
